<template>
  <div
    class="header-search"
    v-if="
      suggestWords.length ||
      products.length ||
      (searchKeywords.length && showRecordLayer)
    "
  >
    <div
      class="header-search__results"
      v-if="suggestWords.length || products.length"
    >
      <ul v-if="count > 0 && cardInfos && cardInfos.length > 0">
        <!-- <ul v-if="count > 0"> -->
        <li class="header-search__item">
          <a
            href="javascript:;"
            @mousedown.prevent="gotoCard()"
            class="clearfix"
          >
            <span class="fl header-search__key">
              <span class="header-search__word">{{ keyword }}</span>
              <strong>{{ TLang("可用福利卡抵扣的商品", "home") }}</strong>
            </span>
            <span class="fr header-search__num"
              >{{ TLang("约", "home") }}{{ count
              }}{{ TLang("个商品", "home") }}</span
            >
          </a>
        </li>
      </ul>
      <ul v-if="suggestWords.length">
        <li
          class="header-search__item"
          v-for="(item, index) of suggestWords"
          :key="`suggestWords_${index}`"
        >
          <a
            href="javascript:;"
            @mousedown.prevent="gotoSuggestWords(item.word)"
            class="clearfix"
          >
            <span
              class="fl header-search__key"
              v-if="item.highlight"
              v-html="item.highlight"
            ></span>
            <span class="fl header-search__key" v-else>{{ item.word }}</span>
          </a>
        </li>
      </ul>
      <ul v-if="products.length">
        <li
          class="header-search__item"
          v-for="(item, index) of products"
          :key="`item${index}`"
        >
          <a
            href="javascript:;"
            @mousedown.prevent="goto(false, item.productType)"
            class="clearfix"
          >
            <span class="fl header-search__key">
              <span class="header-search__word">{{ keyword }}</span>
              <strong>{{ item.productType }}</strong>
            </span>
            <span class="fr header-search__num"
              >{{ TLang("约", "home") }}{{ item.qty
              }}{{ TLang("个商品", "home") }}</span
            >
          </a>
        </li>
      </ul>
    </div>
    <div
      class="header-search__record"
      v-if="searchKeywords.length && showRecordLayer"
    >
      <div class="clearfix header-search__record_all">
        <span class="fl header-search__key">{{
          TLang("最近搜过", "home")
        }}</span>
        <span
          class="fr header-search__num"
          @mousedown.prevent="deleteAllCookies"
          >{{ TLang("全部删除", "home") }}</span
        >
      </div>
      <ul>
        <li
          class="header-search__item"
          v-for="(item, index) of searchKeywords"
          :key="item"
        >
          <a href="javascript:;" class="clearfix">
            <span
              class="fl header-search__key"
              @mousedown.prevent="onSubmit($event)"
              >{{ item }}</span
            >
            <span
              class="fr header-search__num"
              @mousedown.prevent="deleteCurCookie(index)"
              >{{ TLang("删除", "home") }}</span
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { gioClickHandle as gioHandle, getQueryString } from "../../utils";
export default {
  props: {
    searches: {
      type: Array,
      default: () => [],
    },
    suggestWords: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    cardInfos: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 0,
    },
    records: {
      type: Array,
      default: () => [],
    },
    keyword: {
      type: String,
      default: "",
    },
    cid: {
      type: Number,
      default: 145,
    },
    showRecordLayer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchKeywords: this.infoState(this.records),
    };
  },
  methods: {
    infoState(obj) {
      let arr = obj.slice(0, 10);
      return arr;
    },
    goto(picUrl, productType) {
      if (picUrl) {
        const { hostname } = window.location;
        const arr = [...this.searchKeywords].filter(
          (item) => item !== this.keyword
        );

        // arr.push(this.keyword);
        arr.unshift(this.keyword);
        // 设置cookie
        this.publicMethod.setCookie(
          "searchKeywords",
          arr.join(","),
          604800,
          "/",
          `.${hostname}`
        );

        window.df_sdk_common.location.href = picUrl;
      } else {
        gioHandle(
          "DF_elementClick",
          {
            df_channle: "演出",
            df_pagename: "搜索页",
            df_modulename: "快速搜索",
            df_elementname: "产品类型",
            df_pageType: productType,
            df_searchKeyword: this.keyword,
          },
          "channelGio"
        );
        const { origin } = window.location;
        const URL = `${origin}/health/search?keywords=${this.keyword}&productType=${productType}&city=${this.cid}`;

        window.df_sdk_common.location.href = URL;
      }
    },
    gotoSuggestWords(keyword) {
      gioHandle(
        "DF_elementClick",
        {
          df_channle: "演出",
          df_pagename: "搜索页",
          df_modulename: "快速搜索",
          df_elementname: "搜索联想词",
          df_searchKeyword: this.keyword,
          df_content: keyword,
        },
        "channelGio"
      );

      this.$emit("onSubmit", keyword, keyword);
    },
    gotoCard() {
      // cardChoose传1 表示选择了卡权益
      const { origin } = window.location;
      const URL = `${origin}/health/search?keywords=${this.keyword}&city=${this.cid}&cardChoose=1`;

      gioHandle(
        "DF_elementClick",
        {
          df_searchKeyword: this.keyword || "未输入关键词",
          df_modulename: "快速搜索",
          df_elementname: "权益",
          df_pagename: "搜索页",
        },
        "channelGio"
      );

      setTimeout(() => {
        window.df_sdk_common.location.href = URL;
      }, 1000);
    },
    deleteCurCookie(index) {
      const { hostname } = window.location;

      this.searchKeywords.splice(index, 1);
      this.publicMethod.setCookie(
        "searchKeywords",
        this.searchKeywords.join(","),
        604800,
        "/",
        `.${hostname}`
      );
      // 更新搜索历史记录
      this.$emit("updateRecord", this.searchKeywords);
    },
    deleteAllCookies() {
      const { hostname } = window.location;

      this.publicMethod.removeCookie("searchKeywords", "/", `.${hostname}`);
      this.searchKeywords = [];
      // 更新搜索历史记录
      this.$emit("updateRecord", this.searchKeywords);
    },
    async onSubmit(ev) {
      // const res = await this.apis
      this.apis.headerApi
        .getSearchUrl({ keyword: ev.target.innerText })
        .then((res) => {
          gioHandle("DF_elementClick", {
            df_channle: "演出",
            df_pagename: "搜索结果页",
            df_modulename: "搜索关键词",
            df_elementname: "搜索关键词",
            df_searchKeyword: ev.target.innerText,
            df_pageType: res && res.body && res.body.linkUrl ? "词链" : "",
          });
          if (res && res.body && res.body.linkUrl) {
            window.df_sdk_common.location.href = res.body.linkUrl;
          } else {
            this.$emit("onSubmit", ev, ev.target.innerText);
          }
        })
        .catch((err) => {
          gioHandle("DF_elementClick", {
            df_channle: "演出",
            df_pagename: "搜索页",
            df_modulename: "搜索历史",
            df_elementname: "搜索历史词",
            df_searchKeyword: ev.target.innerText,
          });
          this.$emit("onSubmit", ev, ev.target.innerText);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.header-search {
  position: absolute;
  top: 87px;
  right: 0;
  z-index: 9999;
  border: 1px solid #c9c9c9;
  background-color: #fff;
  width: 397px;
  padding-top: 5px;
  padding-bottom: 5px;
  &__item {
    > a {
      display: block;
      padding: 5px 10px;
      &:hover {
        background-color: #f8f8f8;
      }
    }
  }
  &__key {
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
  }
  &__word {
    color: red;
    margin-right: 4px;
  }
  &__num {
    width: 25%;
    text-align: right;
    color: #999;
  }
  &__record {
    &_all {
      padding: 5px 10px;
      .header-search__num {
        cursor: pointer;
      }
    }
    a {
      padding: 5px 10px;
      .header-search__num {
        display: none;
      }
      &:hover {
        .header-search__num {
          display: block;
        }
      }
    }
  }
}

.fl {
  float: left;
}
.fr {
  float: right;
}
</style>
